import React from "react";
import { StyledSubMenuItem } from "../styles/layout/SubMenuItem.styled";

function SubMenuItem({ item }) {
  return <StyledSubMenuItem to={item?.slug}>{item?.name}</StyledSubMenuItem>;
}

export default SubMenuItem;
